import styled from '@emotion/styled';
import { Grid } from '@material-ui/core';
import { Magnetic } from '@mitchell/react.component.ux';
export const StyledIQAGridContainerImage = styled(Grid) `
	padding: 0px 0px 0px ${Magnetic.spacer20};
	width: 340px;
	margin: auto;
	height: 45vh;
`;
export const StyledIQAGridContainerItem = styled(Grid) `
	padding: ${Magnetic.spacer08} 0px;
`;
export const StyledIQAImageLoader = styled('img') `
	margin-top: ${Magnetic.spacer08};
	width: 1.14rem;
	height: 1.14rem;
`;
export const StyledDivSVGImg = styled('div') `
	width: 24px;
	height: 24px;
	background-image: ${(props) => props.svgKey};
	background-repeat: no-repeat;
	background-position: center;
	background-size: contain;
`;
export const StyledImgAnalyzerIcon = styled('span', {
    shouldForwardProp: prop => prop !== 'colorCode'
}) `
	font-size: ${Magnetic.fontSize12};
	color: ${(props) => props.colorCode}};
`;
//# sourceMappingURL=IntelligentPhotoCaptureImageAnalyzerView.style.js.map